export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
  COACH = 'coach',
}

export interface User {
  id: string;
  email: string;
  password?: string; // Optionnel car on ne veut pas toujours l'inclure dans les réponses
  firstName: string;
  lastName: string;
  role: UserRole;
  status: 'inactive' | 'active' | 'suspended';
  club?: string;
  phone?: string;
  source?: string;
  createdAt: string;
  updatedAt: string;
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}
